
import React from 'react';
import Navigation from '@/components/Navigation';
import { PageHeading } from '@/components/ui/page-heading';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Settings } from 'lucide-react';

const SettingsPage = () => {
  return (
    <Navigation>
      <div className="space-y-6">
        <PageHeading 
          title="Settings" 
          description="Configure application settings and preferences"
        />
        
        <Card>
          <CardHeader className="flex flex-row items-center gap-2">
            <Settings className="h-5 w-5 text-muted-foreground" />
            <CardTitle>Application Settings</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground mb-4">
              Manage your account settings, notifications, and preferences.
            </p>
            <div className="bg-muted/50 rounded-md p-8 flex items-center justify-center">
              <p className="text-center text-muted-foreground">
                Settings configuration will be implemented in a future update.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </Navigation>
  );
};

export default SettingsPage;
